class FlixQtyInput extends HTMLElement {
  connectedCallback() {
    this._display = this.querySelector('[data-flix-qty-value]');
    this._dec = this.querySelector('[data-flix-qty-dec]');
    this._inc = this.querySelector('[data-flix-qty-inc]');
    this._qty = parseInt(this.dataset.value, 10) || 1;
    this._sync();
    if (this._dec) this._dec.addEventListener('click', () => this._set(this._qty - 1));
    if (this._inc) this._inc.addEventListener('click', () => this._set(this._qty + 1));
  }

  get value() { return this._qty; }

  _set(n) {
    this._qty = Math.max(1, n);
    this._sync();
    this.dispatchEvent(new CustomEvent('flix:qty:change', { bubbles: true, detail: { value: this._qty } }));
  }

  _sync() {
    if (this._display) this._display.textContent = this._qty;
  }
}
customElements.define('flix-qty-input', FlixQtyInput);
